import { useGameContext } from "../Hook/GameContext";
import {
  GameClubDialogWrapper,
  GameClubDialogHeader,
  GameClubDialogButton,
  GameClubDialogText,
} from "../Style/ClubDialogStyles";
import { GamePage } from "../Hook/useGame";

export const ClubDialog = () => {
  const { setGamePageState, setIsClubDialog } = useGameContext();
  return (
    <GameClubDialogWrapper>
      <div className="content">
        <img src="image-web/game/club-popup.png" alt="배경" />
        <div className="wrapper">
          <GameClubDialogHeader>
            <img
              alt="취소"
              src="/image-web/game/popup/attendance/cancel.svg"
              onClick={() => {
                setIsClubDialog(false);
              }}
            />
          </GameClubDialogHeader>
          <GameClubDialogText>
            우리 동네 클럽 가입하고 <br /> 10만 GP 보상 받자!
          </GameClubDialogText>
          <GameClubDialogButton
            onClick={() => {
              setIsClubDialog(false);
              setGamePageState(GamePage.CLUB);
            }}
          >
            클럽 가입하기
          </GameClubDialogButton>
        </div>
      </div>
    </GameClubDialogWrapper>
  );
};
